import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr'
import { ChatService } from "../app/chat/chat.service"
import { MensagemService } from './mensagem.service';

interface IBootstrapStatus {
    Percentual: number;
    Status: string;
}

@Injectable({
    providedIn: 'root'
})
export class SignalrService {

    constructor(
        private _chatService: ChatService,
        private _mensagemService: MensagemService
    ) {
        this._conversaIniciada.next(this.guid != "")
    }

    private hubConnection: signalR.HubConnection;

    public _conexaoIniciada: BehaviorSubject<boolean> = new BehaviorSubject(null);

    public _mensagemRecebida: BehaviorSubject<number> = new BehaviorSubject(null);

    private _chatFinalizado: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    private _conversaIniciada: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public guidFila: string

    public get guid() {
        var _guid = localStorage.getItem("Qiowio26")
        if (_guid != null && _guid != "") {
            return _guid
        }
        else {
            return "";
        }

    }
    get mensagemRecebida$(): Observable<number> {
        return this._mensagemRecebida.asObservable();
    }

    get conexaoIniciada$(): Observable<boolean> {
        return this._conexaoIniciada.asObservable();
    }

    public set guid(guid) {
        localStorage.setItem("Qiowio26", guid)
        this._conversaIniciada.next(guid != null && guid != "")
    }

    get chatFinalizado$(): Observable<boolean> {
        return this._chatFinalizado.asObservable();
    }

    public get chatFinalizado(): boolean {
        return this._chatFinalizado.value;
    }

    get conversaIniciada$(): Observable<boolean> {
        return this._conversaIniciada.asObservable();
    }

    public marcarConversaIniciada() {
        this._conversaIniciada.next(true)
    }

    public get mensagemIniciada() {
        var _msg: string = localStorage.getItem("Qiowio29")
        if (_msg == null || _msg == "" || _msg == "false") {
            return false
        }
        else {
            return true;
        }

    }

    public set mensagemIniciada(msg) {
        if (msg) {
            localStorage.setItem("Qiowio29", "true")
        }
        else {
            localStorage.setItem("Qiowio29", "false")
        }
    }

    public get pergunta() {
        var _msg: string = localStorage.getItem("Qiowio31")
        if (_msg == null || _msg == "" || _msg == "false") {
            return false
        }
        else {
            return true;
        }

    }

    public set pergunta(msg) {
        if (msg) {
            localStorage.setItem("Qiowio31", "true")
        }
        else {
            localStorage.setItem("Qiowio31", "false")
        }
    }

    public get token() {
        return localStorage.getItem("Qiowio24")
    }

    public set token(token) {
        localStorage.setItem("Qiowio24", token)
    }

    public get chatId() {
        return localStorage.getItem("Qiowio22")
    }

    public set chatId(chatId) {
        localStorage.setItem("Qiowio22", chatId)
    }

    public get chaveSignalR() {
        return localStorage.getItem("Qiowio23")
    }

    public set chaveSignalR(chaveSignalR) {
        localStorage.setItem("Qiowio23", chaveSignalR)
    }

    private _mensagemSaudacao: string = "";

    public get mensagemSaudacao() {
        return this._mensagemSaudacao
    }

    public set mensagemSaudacao(mensagemSaudacao) {
        this._mensagemSaudacao = mensagemSaudacao
    }

    public startConnection = (url) => {

        let strHub = url + 'hubs/chat';

        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(strHub + '?sessao-auth=' + this.chaveSignalR + '&guid=' + this.guid, {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets
            })
            .withAutomaticReconnect(
                {
                    nextRetryDelayInMilliseconds: retryContext => {
                        console.log(`signalRwithAutomaticReconnect - previousRetryCount [${retryContext.previousRetryCount}], elapsedMilliseconds [${retryContext.elapsedMilliseconds}], retryReason [${retryContext.retryReason}]`);
                        if (retryContext.elapsedMilliseconds >= 30000) {
                            return 30000;
                        } else {
                            return retryContext.elapsedMilliseconds + 1000;
                        }
                    }
                }
            )
            .build();

        this.hubConnection
            .start()
            .then(() => {
                console.log('%c ✅ SignalR  - Conexão Inicializada', 'font-size: 14px; font-weight: bold')
                this._conexaoIniciada.next(true);
            }
            )
            .catch(err => console.log('Error durante tentativa de conexão em /hubs/bootstrap: ' + err));
    }

    public disconnect = () => {
        this.hubConnection
            .stop()
            .then(() => console.log('%c ❌ SignalR  - Conexão Encerrada', 'font-size: 14px; font-weight: bold'))
            .catch(err => console.log('Error durante tentativa de desconexão em /hubs/bootstrap: ' + err));
    }

    public addmensagemIndividualListener = () => {
        this.hubConnection.on('mensagemIndividual', (data) => {
            this._chatService.addMessage(this._chatService.sistema, data.mensagem, data.direcao)
            this._mensagemRecebida.next(data.direcao)
        });
    }

    private montarParticipante(data) {

        let user = null

        if (data.Direcao == 0) {
            user = JSON.parse(JSON.stringify(this._chatService.client))

        }
        else {
            user = JSON.parse(JSON.stringify(this._chatService.operator))
            if (!data.Avatar) {
                data.Avatar = this._chatService.logoPadrao;
            }
        }

        if (data.Avatar != null && data.Avatar.startsWith("assets")) {
            user.avatar = this._chatService.appApiUrl + data.Avatar
        }
        else {
            user.avatar = data.Avatar
        }

        user.name = data.Nome;

        if (user.name != this._chatService.operator.name && user.name != "" && data.Direcao != 0) {
            this._chatService.operator.name = user.name
            this._chatService.operator.avatar = user.avatar
        }

        return user
    }

    public addmensagemTodosListener = () => {
        this.hubConnection.on('mensagemTodos', (data) => {
            console.log('%c 🌎 SignalR - ' + data, 'color: green;');
        });
    }

    public addverificarChatAtivoListener = () => {
        this.hubConnection.on('verificarChatAtivo', (data) => {
            console.log('%c 🌎 ESTOU VIVO  ', 'color: green;');
            return true;
        });
    };

    public addMensagensNotifyListener = () => {
        this.hubConnection.on('mensagensNotify', (data) => {
            console.log('%c 😃 Mensagens Notify', 'color: green;', data.evento);

            switch (data.evento) {
              case 'AGENTES_HABILITADOS':
                    if(data.dados.MudouFila){
                        this.guidFila = data.dados.FilaGuid
                    }

                    if (this._chatService?.messages.length > 0 && this.guidFila) {
                        if (data.dados.FilaGuid !== this.guidFila) {
                            console.warn('Ignorando evento: sem mensagens ou GUID diferente');
                            return;
                        }
                    }

                    if (data?.dados?.Status === '1') {
                        this._chatService.operator.status = "online";
                    }
                    else {
                        this._chatService.operator.status = "offline";
                    }
                    break;

                case 'MENSAGEM_FINALIZADA':
                    this.finalizarChat()
                    break;

                default:
                    break;
            }
        });
    };

    public addMensagensTipadasNotifyListener = () => {
        this.hubConnection.on('mensagensTipadasNotifyLote', (data) => {
            console.log('%c 🔔 Mensagens<T> Notify Lote', 'color: green;', data.evento);

            switch (data.evento) {
                case 'MENSAGEM_PARTE':
                    this.guidFila = data?.dados[0].dadosString?.GuidFila
                    data.dados.forEach((item: any) => {
                        const msgParte: any = this.tratarDadosTipado(item);
                        let user = this.montarParticipante(msgParte)

                        this._chatService.addMessage(user, msgParte.CorpoMensagem, msgParte.Direcao, msgParte.Guid, msgParte.Id, false, undefined, msgParte.Botoes)

                        this._mensagemRecebida.next(msgParte.Direcao)
                    });
                    break;

                case 'MENSAGEM_PARTE_MIDIA':
                    data.dados.forEach((item: any) => {
                        const msgParte: any = this.tratarDadosTipado(item);
                        let user = this.montarParticipante(msgParte)

                        this._chatService.addMessage(user, null, msgParte.Direcao, msgParte.Guid, msgParte.Id, true, {
                            size: msgParte.Midia.Tamanho,
                            type: msgParte.Midia.ContentType,
                            name: msgParte.Midia.NomeArquivo,
                            legenda: msgParte.Midia.Legenda,
                            urlArquivo: msgParte.Midia.Url,
                            urlThumbnail: msgParte.Midia.UrlThumb
                        })

                        this._mensagemRecebida.next(msgParte.Direcao)
                    });
                    break;

                case 'MENSAGEM_PARTE_STATUS':
                    break;

                default:
                    break;
            }
        });
    };

    public addInicioMensagemCompletoListener = () => {
        this.hubConnection.on('InicioMensagemCompleto', (data) => {
            if (data.toString() == 'false') {
                console.error("Ouve um Erro na Inicialização da Mensagem (Inscrição na Fila).")
                this.mensagemIniciada = false;
            }
            else {
                this.mensagemIniciada = true;
            }
        });
    }

    public addReconnected = () => {
        this.hubConnection.onreconnected(() => {
            this._mensagemService.getMensagens(this._chatService.chatApiUrl, this.chaveSignalR, this.guid, this.token)
                .subscribe(() => {
                    console.log('%c ✅ SignalR  - Conexão Re-inicializada', 'font-size: 14px; font-weight: bold');
                },
                    err => {
                        if (err.status == 400 && err.error.mensagem == 'Mensagem já finalizada .') {
                            this._mensagemService._dadosMensagem.next(err.error.partes);
                            this.finalizarChat()
                        }
                        else if (err.status == 404) {
                            console.error(`Guid Inexistente na Base :${JSON.stringify(err)}`);
                        }
                        else {
                            console.error(`Ocorreu um erro durante o GET de MENSAGENS do Chat:${JSON.stringify(err)}`);
                        }
                    });

        });
    }

    public addDisconnect = () => {
        this.hubConnection.on('disconnect', (data) => {
            console.log('%c ✋ SignalR - Solicitação de desconexão do servidor: ' + data, 'color: blue;');
        });
    }

    public enviarMensagem(Mensagem: string, Ip: string) {
        this.hubConnection.invoke("MensagemClient", Mensagem, this.guid, Ip);
    }

    public enviarPacoteLocal(Mensagem, direcao = 1) {
        if (this.hubConnection != null) {
            this.hubConnection.invoke("EnviarPacoteLocal", Mensagem, direcao)
                .catch(() => {
                    this._chatService.addMessage(this._chatService.sistema, Mensagem, 1);
                });
        }
        else {
            this._chatService.addMessage(this._chatService.sistema, Mensagem, 1);
        }
    }

    public iniciarMensagem(Mensagem: string, Ip: string) {
        this.marcarConversaIniciada()
        this.reabrirChat()
        this.hubConnection.invoke("IniciarMensagem", Mensagem, Ip).then((response) => {
            this.guid = response;
        });
    }

    public enviarMensagemSaudacao() {
        if (this.mensagemSaudacao != "" && this.mensagemSaudacao != null) {
            this.enviarPacoteLocal(this.mensagemSaudacao)
        }
    }

    public finalizarChat() {
        if (this._chatFinalizado.value) {
            return;
        }
        this._chatService.resetOperator()
        this._chatService.addEvento("Atendimento encerrado")
        this._chatFinalizado.next(true)
        this.guid = "";
        this._mensagemRecebida.next(0)
    }

    public reabrirChat() {
        this._chatFinalizado.next(false)
    }

    private tratarDadosTipado(dados: any): any {

        if (!dados) {
            return null;
        }
        const tratado = {
            ...dados.dadosString,
            ...dados.dadosNumerico,
            ...dados.dadosBoleano,
            ...this.tratarDadosTimestamp(dados.dadosTimestamp),
            ...this.tratarDadosObjeto(dados.dadosObjeto),
            ...this.tratarDadosLista(dados.dadosLista),
        };
        return tratado;
    }

    private tratarDadosObjeto(dados: any): any {

        if (!dados) {
            return null;
        }
        Object.entries(dados).forEach(([key, value]) => {
            dados[key] = this.tratarDadosTipado(value);
        });
        return dados;
    }

    private tratarDadosTimestamp(dados: any): any {

        if (!dados) {
            return null;
        }
        Object.entries(dados).forEach(([key, value]) => {
            dados[key] = this.formatarTimestamp(value);
        });
        return dados;
    }

    private tratarDadosLista(dados: any): any {

        if (!dados) {
            return null;
        }
        Object.entries(dados).forEach(([key, value]) => {
            dados[key] = value['items'];
        });
        return dados;
    }

    private formatarTimestamp(timestamp: any): string {

        const date = new Date(timestamp.seconds * 1000); // converte segundos para milissegundos

        const isoBase = date.toISOString(); // Ex: "2025-09-19T18:09:31.000Z"
        const [datePart, timePart] = isoBase.split('T');
        const [hh, mm, ssMs] = timePart.replace('Z', '').split(':');
        const [ss, ms] = ssMs.split('.');

        const nanosStr = timestamp.nanos.toString().padStart(9, '0').slice(0, 7);

        return `${datePart}T${hh}:${mm}:${ss}.${nanosStr}+00:00`;
    }
}
